import request from '@/middleware/request'

const getApiLog = data => {
  return request({
    url: '/api_log/list',
    method: 'post',
    data
  })
}

const getDataFilter = () => {
  return request({
    url: `/api_log/data_filter`,
    method: 'get'
  })
}

const getApiLogDetail = id => {
  return request({
    url: `/api_log/${id}`,
    method: 'get'
  })
}
const getCSV = data => {
  return request({
    url: '/api_log/csv',
    method: 'post',
    data
  })
}

export default {
  getApiLog,
  getDataFilter,
  getApiLogDetail,
  getCSV
}
